import {DynField} from '../../dyn-field';
import {DynSelectFieldOptions} from './dyn-select-field-options';
import {DynFieldData} from '../../../data/dyn-field-data';

export class DynSelectField
    extends DynField {

    private options: DynSelectFieldOptions<any>;

/*
    public static createFromObject(object: Object): DynSelectField {
        const field = new DynSelectField();
        field.updateFormObject(object);
        return field;
    }

    protected updateFormObject(object: Object) {
        super.updateFormObject(object);
        this.options = DynSelectFieldOptions.createFromObject(object['options'])

    }
*/
    public constructor(id: number = null, name: string = null, label: string = null,
                       selectFieldOptions: DynSelectFieldOptions<any> = null) {
        super(id, 'select', name, label);
        this.options = selectFieldOptions;
    }

    getOptions(): DynSelectFieldOptions<any> {
        return this.options;
    }

    setOptions(value: DynSelectFieldOptions<any>) {
        this.options = value;
    }


    public getValueAsString(data: DynFieldData): string {
        return this.getOptions().getValueAsString(this.getValue(data));
    }

    /*
    public getValue(data: DynFieldData): any {
        return this.options.getOptions().find(opt => opt.id === +data.getValue());
    }

    public setValue(data: DynFieldData, value: any) {
        data.setValue(value.id);
    }
    */
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/select/dyn-select-field.ts